import React from 'react';

import { ModeIcon } from '@/components/mode-icon';
import { SegmentModeType } from '@/types/api-types';
import { getTransportColor } from '@/utils/helpers/get-transport-color';
import { tv } from '@/utils/styles';

const endMarkerColorConfig: Record<SegmentModeType, string> = {
  water: 'bg-transport-ship',
  air: 'bg-transport-plane',
  road: 'bg-grey-500',
  rail: 'bg-transport-rail',
  transfer: 'bg-transport-transfer',
};

interface SegmentModeBarProps {
  mode: SegmentModeType;
  showEndMarker?: boolean;
}

const SegmentModeBar = ({ mode, showEndMarker = false }: SegmentModeBarProps) => {
  const modeColor = getTransportColor(mode);
  const { base, wrapper, background, iconContainer, endMarker } = styles();

  return (
    <div className={base()}>
      <div className={wrapper()}>
        <div style={{ backgroundColor: modeColor }} className={background()} />
        <div className={iconContainer()}>
          <ModeIcon mode={mode} size="sm" />
        </div>
        {showEndMarker && <div className={endMarker({ className: endMarkerColorConfig[mode] })} />}
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex rounded-full bg-white',
    wrapper: 'relative',
    background: 'absolute bottom-0 left-0 right-0 top-0 rounded-full opacity-50',
    iconContainer: 'relative',
    endMarker: 'absolute bottom-[5px] left-[5px] block h-2.5 w-2.5 rounded-full opacity-80',
  },
});

export { SegmentModeBar };
